var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7134_14180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1.125C7.29293 1.125 8.53291 1.63861 9.44715 2.55285C10.3614 3.46709 10.875 4.70707 10.875 6C10.875 7.29293 10.3614 8.53291 9.44715 9.44715C8.53291 10.3614 7.29293 10.875 6 10.875C4.70707 10.875 3.46709 10.3614 2.55285 9.44715C1.63861 8.53291 1.125 7.29293 1.125 6C1.125 4.70707 1.63861 3.46709 2.55285 2.55285C3.46709 1.63861 4.70707 1.125 6 1.125ZM6 12C7.5913 12 9.11742 11.3679 10.2426 10.2426C11.3679 9.11742 12 7.5913 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12ZM4.10156 4.10156C3.88125 4.32188 3.88125 4.67812 4.10156 4.89609L5.20312 5.99766L4.10156 7.09922C3.88125 7.31953 3.88125 7.67578 4.10156 7.89375C4.32188 8.11172 4.67812 8.11406 4.89609 7.89375L5.99766 6.79219L7.09922 7.89375C7.31953 8.11406 7.67578 8.11406 7.89375 7.89375C8.11172 7.67344 8.11406 7.31719 7.89375 7.09922L6.79219 5.99766L7.89375 4.89609C8.11406 4.67578 8.11406 4.31953 7.89375 4.10156C7.67344 3.88359 7.31719 3.88125 7.09922 4.10156L5.99766 5.20312L4.89609 4.10156C4.67578 3.88125 4.31953 3.88125 4.10156 4.10156Z",
    fill: "#F14242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7134_14180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcon);
export default __webpack_public_path__ + "static/media/rejected_icon.db9f841c92d3936d17905c6abacf6232.svg";
export { ForwardRef as ReactComponent };